import { getOnboardingUserIdFromJwt } from './onboardingJwt';

export const createOnboardingUserStorage = (storageKey: string) => {
  const userStorageKey = (providedUserId?: string): string => {
    const userId = providedUserId ?? getOnboardingUserIdFromJwt();
    return userId ? `${storageKey}:${userId}` : storageKey;
  };

  return {
    mark: (userId?: string): void => {
      try {
        window.localStorage.setItem(userStorageKey(userId), '1');
      } catch {
        // Ignore unavailable browser storage.
      }
    },
    clear: (userId?: string): void => {
      try {
        window.localStorage.removeItem(userStorageKey(userId));
        window.localStorage.removeItem(storageKey);
      } catch {
        // Ignore unavailable browser storage.
      }
    },
    isMarked: (userId?: string): boolean => {
      try {
        return window.localStorage.getItem(userStorageKey(userId)) === '1';
      } catch {
        return false;
      }
    },
  };
};
